export enum UnitType {
    STRING = "STRING",
    NUMERIC = "NUMERIC",
    CURRENCY = "CURRENCY",
    PERCENTAGE = "PERCENTAGE",
}
